import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { api } from 'src/app/@shared/services/api';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeneralConfigService {
  public api = api;
  public env = environment;
  public version!: string;
  public apiEndpointSomeData!: string;

  constructor(private http: HttpClient) { }

  // load(): Promise<any> {
  //   const promise = this.http.get(this.env.baseUrl + this.api.googleConfig)
  //     .toPromise()
  //     .then(data => {
  //       Object.assign(this, data);
  //       return data;
  //     });

  //   return promise;
  // }

  load(): Promise<any> {
    const promise = new Promise<any>((resolve, reject) => {
      this.env.isMobile = (window.navigator.userAgent.includes('Mobile')) ? true : false;
      
      resolve(this.env.isMobile)
    });

    return promise;
  }
}

